import { Avatar, Group, Text } from "@mantine/core"

import { ChangeDetails } from "@costory/shared/utils/changeCalculation"

interface ChangeIndicatorProps {
  /** The change details object from calculateRelativeChange */
  changeDetails: ChangeDetails
  label?: string
  avatarSize?: number
  gap?: number
  showIcon?: boolean
  valueSize?: "xs" | "sm" | "md" | "lg" | "xl"
  changeSize?: "xs" | "sm" | "md" | "lg" | "xl"
}

export const ChangeIndicator = ({
  changeDetails: {
    formattedCurrent,
    percentChange,
    icon,
    color,
    formattedPrevious,
    diff,
  },
  label,
  avatarSize = 18,
  gap = 4,
  showIcon = true,
  valueSize = "md",
  changeSize = "sm",
}: ChangeIndicatorProps) => {
  const displayPercent =
    percentChange === "100%" && formattedPrevious === "$0" && diff > 0
      ? "∞%"
      : percentChange

  return (
    <Group gap={gap}>
      <Text fw={600} size={valueSize}>
        {formattedCurrent}
        {label ? ` ${label}` : ""}
      </Text>

      {showIcon && displayPercent !== "0%" && (
        <Avatar radius="xl" size={avatarSize} color={color} variant="light">
          {icon}
        </Avatar>
      )}

      <Text size={changeSize} fw={500} c={color}>
        {displayPercent}
      </Text>
    </Group>
  )
}
